export default __webpack_public_path__ + "static/media/002-cotton candy.57ec35e3.svg";